module.exports = __webpack_public_path__ + "img/pdf.179d4b3c.svg";